import { API, getAuthToken } from "@/lib/api";

const tok = () => encodeURIComponent(getAuthToken() || "");
export const designImg = (id, thumb, v = "") => `${API}/designs/${id}/image?thumb=${thumb ? "true" : "false"}&auth=${tok()}&v=${encodeURIComponent(v || "")}`;
export const designDxf = (id) => `${API}/designs/${id}/dxf?auth=${tok()}`;
export const fmtDate = (s) => {
  if (!s) return "";
  try {
    return new Date(s).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric", timeZone: "Asia/Kolkata" });
  } catch (_e) { return s; }
};
